import { ResultOf } from "gql.tada";
import { GetConversionPageById } from "@queries/archetypes/GetConversionPageById";
import { GetStartedSection } from "@components/entries/GetStartedSection";
import { MediaGallerySection } from "@components/entries/MediaGallerySection";

type ConversionPageData = NonNullable<
  ResultOf<typeof GetConversionPageById>["conversionPage"]
>;

export const ConversionPageRenderer = ({
  data,
}: {
  data: ConversionPageData;
}) => {
  return (
    <>
      {data.getStarted && (
        <GetStartedSection
          entry={{ getStartedSection: data.getStarted } as any}
        />
      )}
      {data.list && (
        <MediaGallerySection entry={data.list as any} />
      )}
    </>
  );
};
